"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentSignUpDto = /** @class */ (function () {
    function TournamentSignUpDto() {
    }
    return TournamentSignUpDto;
}());
exports.default = TournamentSignUpDto;
